export interface ICustomer {
  id?: string;
  name?: string;
  last_name?: string;
  mother_last_name?: string;
  email?: string;
  phone?: string;
  rfc?: string;
  business_name?: string;
  email_verified_at?: string;
  phone_verified_at?: string;
  has_credit?: number;
  creditMovements: ICreditMovement[];
  verification_code?: IVerificationCode;
  type?: string;
  mobil?: string;
}

export interface ICreditMovement {
  id: string | number;
  created_at: string;
  amount: string;
  type_text: string;
  canceled_at: string;
  transaction_payment_id: string;
}
export interface IVerificationCode {
  id: string | number;
  assigned_to: string;
  amount: string;
  reason: string;
  action: string;
  code: string;
  time: number;
  is_used: number;
}

export default class Customer implements ICustomer {
  public type: string = "customers";
  public relationshipNames: string[] = [];

  public id?: string;
  public name?: string;
  public last_name?: string;
  public mother_last_name?: string;
  public email?: string;
  public rfc?: string;
  public phone?: string;
  public email_verified_at?: string;
  public phone_verified_at?: string;
  public business_name?: string;
  public has_credit: number = 0;
  public creditMovements: ICreditMovement[] = [];
  public mobil?: string;
  public customer_type?: string;
  public verification_code: IVerificationCode = {
    id: "",
    assigned_to: "",
    amount: "",
    reason: "",
    action: "",
    code: "",
    time: 0,
    is_used: 0,
  };

  public constructor(data?: ICustomer) {
    if (data) {
      this.setData(data);
    }
  }

  public setData({
    id,
    name,
    last_name,
    mother_last_name,
    email,
    rfc,
    phone,
    email_verified_at,
    phone_verified_at,
    business_name,
    has_credit,
    creditMovements,
    verification_code,
    mobil,
    type,
  }: ICustomer) {
    this.id = id;
    this.name = name;
    this.last_name = last_name;
    this.mother_last_name = mother_last_name;
    this.email = email;
    this.phone = phone;
    this.email_verified_at = email_verified_at;
    this.rfc = rfc;
    this.phone_verified_at = phone_verified_at;
    this.business_name = business_name;
    this.has_credit = has_credit || 0;
    this.creditMovements = creditMovements;
    this.verification_code = verification_code || {
      id: "",
      assigned_to: "",
      amount: "",
      reason: "",
      action: "",
      code: "",
      time: 0,
      is_used: 0,
    };
    this.mobil = mobil;
    this.customer_type = type; // se hace cambio porque type es usado por jsonapi
  }
}
